var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"logou_text",on:{"click":_vm.logoutMe}},[_vm._v(_vm._s(_vm.$t('logout'))+" "),_c('b-icon',{staticClass:"card_chevron chevron_logout",attrs:{"icon":"chevron-right"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }